<template>
    <div class="content_div">
        <el-card>
            <el-form :inline="true" :model="query" class="demo-form-inline" style="margin-bottom: 20px;">
                <el-form-item label="学生姓名">
                    <el-input clearable v-model="query.userName" placeholder="请输入学生姓名"></el-input>
                </el-form-item>
                <el-form-item label="单词">
                    <el-input clearable v-model="query.word" placeholder="请输入单词"></el-input>
                </el-form-item>
                <el-form-item label="掌握程度">
                    <el-select v-model="query.masteryLevel" placeholder="请选择掌握程度" clearable>
                        <el-option label="未学习" :value="0"></el-option>
                        <el-option label="初学" :value="1"></el-option>
                        <el-option label="熟悉" :value="2"></el-option>
                        <el-option label="精通" :value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
            </el-form>

            <el-table :data="list" border>
                <el-table-column type="index" label="编号" width="80"/>
                <el-table-column prop="userName" label="学生姓名"/>
                <el-table-column prop="word" label="单词"/>
                <el-table-column prop="chineseMeaning" label="中文释义"/>
                <el-table-column prop="masteryLevel" label="掌握程度" width="100">
                    <template slot-scope="scope">
                        <el-tag :type="getMasteryTagType(scope.row.masteryLevel)">
                            {{ getMasteryText(scope.row.masteryLevel) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="correctCount" label="正确次数" width="90"/>
                <el-table-column prop="wrongCount" label="错误次数" width="90"/>
                <el-table-column prop="lastStudyDate" label="最后学习时间" width="160"/>
                <el-table-column prop="nextReviewDate" label="下次复习时间" width="160"/>
                <el-table-column align="center" label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-edit" @click="btnUpdate(scope.row)">更新进度</el-button>
                        <el-button type="text" icon="el-icon-delete" @click="btnDelete(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            
            <el-pagination 
                style="margin-top:10px;"
                background
                layout="total,prev, pager, next"
                @current-change="currentChange"
                :page-size="query.pageSize"
                :total="total">
            </el-pagination>
        </el-card>

        <!-- 更新进度对话框 -->
        <el-dialog :close-on-click-modal="false" title="更新学习进度" :visible.sync="dialogVisible" width="50%">
            <el-form :model="formData" ref="formData" :rules="rules" label-width="100px">
                <el-form-item label="学生">
                    <el-input v-model="formData.userName" disabled></el-input>
                </el-form-item>
                <el-form-item label="单词">
                    <el-input v-model="formData.word" disabled></el-input>
                </el-form-item>
                <el-form-item label="掌握程度" prop="masteryLevel">
                    <el-select v-model="formData.masteryLevel" placeholder="请选择掌握程度" style="width: 100%">
                        <el-option label="未学习" :value="0"></el-option>
                        <el-option label="初学" :value="1"></el-option>
                        <el-option label="熟悉" :value="2"></el-option>
                        <el-option label="精通" :value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="正确次数" prop="correctCount">
                    <el-input-number v-model="formData.correctCount" :min="0" placeholder="累计正确次数"></el-input-number>
                </el-form-item>
                <el-form-item label="错误次数" prop="wrongCount">
                    <el-input-number v-model="formData.wrongCount" :min="0" placeholder="累计错误次数"></el-input-number>
                </el-form-item>
                <el-form-item label="最后学习时间" prop="lastStudyDate">
                    <el-date-picker v-model="formData.lastStudyDate" type="datetime" placeholder="选择时间" style="width: 100%"></el-date-picker>
                </el-form-item>
                <el-form-item label="下次复习时间" prop="nextReviewDate">
                    <el-date-picker v-model="formData.nextReviewDate" type="datetime" placeholder="选择时间" style="width: 100%"></el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitForm">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { reqLearnProgressPage, reqLearnProgressUpdate, reqLearnProgressDelete } from '@/api/education/learn-progress'

export default {
    name: 'Progress',
    data() {
        return {
            list: [],
            total: 0,
            query: {
                currentPage: 1,
                pageSize: 10,
                userName: '',
                word: '',
                masteryLevel: null
            },
            dialogVisible: false,
            formData: {
                id: null,
                userId: null,
                userName: '',
                wordId: null,
                word: '',
                chineseMeaning: '',
                masteryLevel: 0,
                correctCount: 0,
                wrongCount: 0,
                lastStudyDate: '',
                nextReviewDate: ''
            },
            rules: {
                masteryLevel: [
                    { required: true, message: '请选择掌握程度', trigger: 'change' }
                ]
            }
        }
    },
    created() {
        this.load()
    },
    methods: {
        getMasteryText(level) {
            const map = { 0: '未学习', 1: '初学', 2: '熟悉', 3: '精通' }
            return map[level] || '未知'
        },
        getMasteryTagType(level) {
            const map = { 0: 'info', 1: 'warning', 2: 'primary', 3: 'success' }
            return map[level] || 'info'
        },
        async load() {
            const data = await reqLearnProgressPage(this.query)
            this.list = data.records
            this.total = data.total
        },
        currentChange(num) {
            this.query.currentPage = num
            this.load()
        },
        btnUpdate(row) {
            this.formData = JSON.parse(JSON.stringify(row))
            this.dialogVisible = true
        },
        async btnDelete(id) {
            this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                await reqLearnProgressDelete(id)
                this.$message.success('删除成功')
                this.load()
            }).catch(() => {
                this.$message.info('已取消删除')
            })
        },
        submitForm() {
            this.$refs.formData.validate(async valid => {
                if (valid) {
                    await reqLearnProgressUpdate(this.formData)
                    this.$message.success('操作成功')
                    this.dialogVisible = false
                    this.load()
                }
            })
        }
    }
}
</script>

<style scoped>
</style>
